import React from 'react';
import { useIntl } from 'react-intl';
import { compact } from 'lodash';
import classnames from 'classnames';

import CareersCard from '../../CareersCard';
import { CareerFragment, Maybe } from '../../../../graphql.schema';

import * as styles from './index.module.scss';

type CareerGalleryType = {
  careerPosts?: Maybe<Maybe<CareerFragment>[]> | undefined;
};

export const StrapiCareersGallery = ({ careerPosts }: CareerGalleryType) => {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <h2 className={classnames('is-2 title brand-a', styles.header)}>{intl.formatMessage({ id: 'careerCardHeading', defaultMessage: 'Careers' })}</h2>
      <div className={styles.gridWrapper}>
        {compact(careerPosts).map(({ id, title, slug, short, jobType, city }: CareerFragment) => {
          if (!slug) return null;
          return (
            <CareersCard
              linkText={intl.formatMessage({ id: 'careerCardLink', defaultMessage: 'View Opportunity' })}
              slugBase="careers"
              jobType={jobType?.name ?? ''}
              city={city?.name ?? ''}
              key={`career-${id}`}
              title={title ?? 'N/A'}
              short={short ?? ''}
              slug={slug}
            />
          );
        })}
      </div>
    </div>
  );
}
